// extracted by mini-css-extract-plugin
export default {"title":"create_title__ZCp-p","container":"create_container__WLsuV","header":"create_header__8+mFJ"};